// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YAAtC9X0pn4wBFqXtB3e{border-bottom:1px solid var(--border-neutral-default);cursor:pointer;justify-content:space-between;align-items:center;padding:12px 14px 9px;display:flex;position:relative}.QdRAfhQyXakFJS9lpZy_{align-items:center;display:flex}.mX4q3124H3I3sYQ6vK3I{margin-right:6px}.ZpSZtv25fAz2JKoEAjez{z-index:var(--zIndex-BASE_10);position:absolute;top:0;bottom:0;left:0;right:0}.rquz0khjXI0BHcID2M9z{color:var(--content-primary-primary);-webkit-user-select:none;user-select:none;z-index:var(--zIndex-BASE_15);margin-right:5px;font-size:12px;font-weight:400}.gf_AtuyDZMk1iMVLheNw{margin-right:4px}.sxta5W8A84I3mP6J7lw6{color:var(--content-primary-tertiary);-webkit-user-select:none;user-select:none;z-index:var(--zIndex-BASE_15);font-size:12px;font-weight:400}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head": `YAAtC9X0pn4wBFqXtB3e`,
	"head__box": `QdRAfhQyXakFJS9lpZy_`,
	"headBox": `QdRAfhQyXakFJS9lpZy_`,
	"head__icon": `mX4q3124H3I3sYQ6vK3I`,
	"headIcon": `mX4q3124H3I3sYQ6vK3I`,
	"head__drag": `ZpSZtv25fAz2JKoEAjez`,
	"headDrag": `ZpSZtv25fAz2JKoEAjez`,
	"head__label": `rquz0khjXI0BHcID2M9z`,
	"headLabel": `rquz0khjXI0BHcID2M9z`,
	"head__ellipse": `gf_AtuyDZMk1iMVLheNw`,
	"headEllipse": `gf_AtuyDZMk1iMVLheNw`,
	"head__number": `sxta5W8A84I3mP6J7lw6`,
	"headNumber": `sxta5W8A84I3mP6J7lw6`
};
export default ___CSS_LOADER_EXPORT___;
